import axios from "axios";
import { API_BASE_URL } from "../environment";

export const createNewRetailers = async (data) => {
  const res = await axios.post(`${API_BASE_URL}/retailer/add`, data);
  return res.data;
};
export const getAllRetailers = async (data) => {
  const res = await axios.get(
    `${API_BASE_URL}/retailer?start_date=${data.start_date}&end_date=${data.end_date}`
  );
  return res.data;
};
export const getRetailersById = async (id) => {
  const res = await axios.get(`${API_BASE_URL}/retailer/${id}`);
  return res.data;
};

export const updateRetailers = async (id, data) => {
  const res = await axios.patch(
    `${API_BASE_URL}/retailer/${id}`,
    data
  );
  return res.data;
};
